define('modules/common/controller/Fascicoli',[], function() {
    var Controller = function(
        $scope,
        $state,
        $modal,
        ListaFascicoli,
        Studio,
        $location) {

        $scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
            if (toState.name !== 'fascicoli') {
                $location.search('query', null);
            }
        });

        $scope.onEnter = function() {
            $state.go('fascicoli', {
                'aliasStudio': Studio.getAlias(),
                'query': $scope.queryFascicoli
            });
        };

        $scope.queryFlag = !!$location.search().query;
        $scope.busy = true;

        $scope.queryFascicoli = $location.search().query;


        $scope.clearSearch = function() {
            $scope.queryFascicoli = "";
            $scope.onEnter();
        };

        $scope.dettagli = function(hrefFascicolo) {
            $state.go('fascicolo.dettagli', {
                aliasStudio: Studio.getAlias(),
                hrefFascicolo: hrefFascicolo.split('/').join('___')
            });
        };

        $scope.lock = false;
        $scope.listaFascicoli = [];
        $scope.campoordinamento = 'intestazione';
        $scope.ordinamentoasc = true;

        var aggiornaScope = function(lista) {

            $scope.listaFascicoli = $scope.listaFascicoli.concat(lista);
            $scope.canGetNext = ListaFascicoli.canGetNext();
        };

        ListaFascicoli.setQuery($location.search().query);
        ListaFascicoli.setPaginazione(20);
        ListaFascicoli.setSort($scope.campoordinamento, ($scope.ordinamentoasc ? 'asc' : 'desc'));
        ListaFascicoli.get().then(function(lista) {
            aggiornaScope(lista);
            $scope.busy = false;
        });

        $scope.getNext = function() {
            if (!$scope.lock) {
                $scope.lock = true;
                ListaFascicoli.getNext().then(function(lista) {
                    aggiornaScope(lista);
                    $scope.lock = false;
                });
            }
        };

        $scope.sortBy = function(campo) {
            if (!$scope.lock) {
                $scope.lock = true;
                $scope.campoordinamento = campo;
                $scope.ordinamentoasc = !$scope.ordinamentoasc;
                ListaFascicoli.setSort($scope.campoordinamento, ($scope.ordinamentoasc ? 'asc' : 'desc'));
                $scope.listaFascicoli = [];
                ListaFascicoli.get().then(function(lista) {
                    aggiornaScope(lista);
                    $scope.lock = false;
                });
            }
        };



        $scope.apriModaleNote = function(nota) {
            if (nota) {

                $modal.open({
                    animation: true,
                    resolve: {
                        testoNota: function() {
                            return nota;
                        }
                    },
                    templateUrl: 'modules/common/view/modalNote.tpl.html',
                    controller: 'ModalNoteController',
                    size: "lg"
                });
            }
        };


    };

    return [
        "$scope",
        "$state",
        "$modal",
        "ListaFascicoli",
        "Studio",
        "$location",
        Controller
    ];
});

